// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2UORg","Success":"Button_Success__1v4EA","Danger":"Button_Danger__1-11X"};